import { EnumUserPermission } from "@/app/services/generated/enums/enumUserPermission.generated";
import { MenuItem } from "@/app/ui/navigation/types";
import { hasPermissionsUsingUserStore } from "@/components/pages/administration/user_roles/UserAccessHandler";

export const multiTenantMenu = {
  root: "navigation_multi_tenant_group",
  products_in_stock: "products_in_stock",
};

export const buildMultiTenantMenuItems: () => MenuItem[] = () => [
  MenuItem.forBranch({
    name: multiTenantMenu.root,
    icon: "share",
    visible: () =>
      hasPermissionsUsingUserStore([EnumUserPermission.menuMultiTenantView]),
    subMenus: [
      MenuItem.fromOpts({
        name: multiTenantMenu.products_in_stock,
        url: "/multi-tenant/products-in-stock",
        breadcrumbParentName: multiTenantMenu.root,
        view: (): Promise<any> =>
          import(
            /* webpackChunkName: "multi-tenant" */ "@/components/pages/multi-tenant/MultiTenantProductsInStockPage.vue"
          ),
      }),
    ],
    requiredUserPermissions: [EnumUserPermission.multiTenant],
  }),
];
